import React, { useState } from "react";
import { Highlight, themes } from "prism-react-renderer";
import Editor from "react-simple-code-editor";
import { Box, IconButton, ContentCopyFilledIcon, CheckCircleIcon } from "convertupleads-theme";

let commandColors = ["#afa", "#FFFAD7", "#faf"];

const highlight = (code, language) => (
  <Highlight code={code} language={language} theme={themes.nightOwl}>
    {({ tokens, getLineProps, getTokenProps }) => (
      <>
        {tokens.map((line, i) => (
          <div key={i} {...getLineProps({ line, key: i })}>
            {line.map((token, key) => {
              if (language !== "npm") {
                return <span key={key} {...getTokenProps({ token, key })} />;
              }
              if (token.content) {
                return token.content
                  .split(" ")
                  .map((eachCommand, commandIndex) => (
                    <span
                      key={key}
                      children={eachCommand}
                      style={{
                        marginRight: "8px",
                        color: commandColors[commandIndex] ?? "#fff",
                      }}
                    />
                  ));
              }

              return "";
            })}
          </div>
        ))}
      </>
    )}
  </Highlight>
);

const BashEditor = ({ code = "", language = "js" }) => {
  const [copied, setCopied] = useState(false);
  return (
    <Box sx={{ position: "relative" }}>
      <IconButton
        aria-label="delete"
        size="small"
        sx={{ position: "absolute", zIndex: 1, right: 3, top: 3 }}
        onClick={() => {
          setCopied(!copied);
          navigator.clipboard.writeText(code);
        }}
      >
        {copied ? (
          <CheckCircleIcon fontSize="inherit" />
        ) : (
          <ContentCopyFilledIcon fontSize="inherit" />
        )}
      </IconButton>
      <Editor
        readOnly
        value={code}
        highlight={(code) => highlight(code, language)}
        padding={30}
        style={{
          fontFamily: "monospace",
          outline: "0px",
          background: "black",
          maxHeight: "250px",
          overflowY: "auto",
          caretColor: "white",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      />
    </Box>
  );
};

export default BashEditor;
